import {amber, blueGrey, green, red} from '@mui/material/colors';

import {PlannerStatus, PresenceState} from './plannerModel';

/**
 * Ampelfarben des aus dem Kalender **gerechneten** Zustands — grün heißt „jetzt ansprechbar".
 */
export const STATUS_COLOR: Record<Exclude<PlannerStatus, 'unknown'>, string> = {
    free: green[600],
    busy: amber[800],
    absent: blueGrey[400],
};

/**
 * Farben des **gemeldeten** Teams-Status — dieselben, die Teams selbst verwendet.
 *
 * Bewusst nicht die Ampelfarben darüber: die stehen für den geplanten Zustand, diese für den
 * gemeldeten. Gleiche Farben für beides würde die zwei Aussagen zu einer verschmelzen.
 */
export const PRESENCE_COLOR: Record<PresenceState, string> = {
    available: green[600],
    busy: red[600],
    doNotDisturb: red[900],
    away: amber[700],
    offline: blueGrey[400],
};

/**
 * Zustand als Text, mit dem Zeitpunkt, bis wann er gilt.
 *
 * Liegt hier und nicht in der Tafel, weil ihn auch die Telefonansicht braucht — und ein Zustand,
 * der an zwei Stellen verschieden heißt, ist schlimmer als einer, der nirgends steht.
 */
export const statusText = (
    status: PlannerStatus,
    until: string | undefined,
    t: (key: string, options?: Record<string, unknown>) => string,
): string => {
    if (status === 'absent') return t('planner.statusAbsent');
    if (status === 'busy') {
        return until ? t('planner.statusBusyUntil', {time: until}) : t('planner.statusBusy');
    }
    return until ? t('planner.statusFreeUntil', {time: until}) : t('planner.statusFree');
};
